import React from "react";
import clsx from "clsx";
import { ExternalLink } from "lucide-react";
import {
  Button,
  ButtonVariant,
  Card,
  SkeletonLoader,
  Text,
} from "@merge-api/merge-javascript-shared";
import { MERGE_COMMON_MODEL_SCOPES_HELP_CENTER } from "../../../../../../router/RouterUtils";
import { SCOPE_COLUMN_CLASS, SCOPE_TABLE_MIN_WIDTH_CLASS } from "../constants";

const PLACEHOLDER_ROWS = Array.from({ length: 8 });

/** Loading placeholder for ScopesTable that keeps the header/column chrome in place. */
const ScopesTableSkeleton = () => (
  <Card className="overflow-hidden">
    <div className="overflow-x-auto">
      <div className={SCOPE_TABLE_MIN_WIDTH_CLASS}>
        <div className="flex items-center border-b border-gray-10 px-4 py-3">
          <div className={SCOPE_COLUMN_CLASS.object}>
            <Text variant="pre-title">Object</Text>
          </div>
          <div className={SCOPE_COLUMN_CLASS.read}>
            <Text variant="pre-title">Read permissions</Text>
          </div>
          <div className={SCOPE_COLUMN_CLASS.write}>
            <Text variant="pre-title">Write permissions</Text>
          </div>
          {/* Unlabeled spacer aligning with the per-row deprecated-badge column. */}
          <div className={SCOPE_COLUMN_CLASS.status} />
          <div className={clsx(SCOPE_COLUMN_CLASS.fields, "text-left")}>
            <Text variant="pre-title">Fields</Text>
          </div>
          {/* Docs link in its own column, matching the loaded table's header. */}
          <div className={clsx(SCOPE_COLUMN_CLASS.expand, "flex items-center justify-end")}>
            <Button
              variant={ButtonVariant.TextBlue}
              size="sm"
              onClick={() =>
                window.open(MERGE_COMMON_MODEL_SCOPES_HELP_CENTER, "_blank", "noopener,noreferrer")
              }
              rightIcon={<ExternalLink size={12} />}
              className="shrink-0"
            >
              Learn more in docs
            </Button>
          </div>
        </div>
        {PLACEHOLDER_ROWS.map((_, index) => (
          <div
            key={index}
            className={clsx("flex items-center px-4 py-3", index > 0 && "border-t border-gray-10")}
          >
            <SkeletonLoader fullWidth height={24} borderRadius={8} className="block w-full" />
          </div>
        ))}
      </div>
    </div>
  </Card>
);

export default ScopesTableSkeleton;
